import create from 'zustand';

const STORAGE_KEY = 'compact-mode';

const readPersisted = (): boolean => {
   try { return localStorage.getItem(STORAGE_KEY) === 'true'; } catch { return false; }
};

const initial = readPersisted();
document.documentElement.classList.toggle('compact', initial);

interface CompactModeState {
   isCompact: boolean;
   toggleCompact: () => void;
}

export const useCompactMode = create<CompactModeState>((set, get) => ({
   isCompact: initial,
   toggleCompact: () => {
      const next = !get().isCompact;
      try { localStorage.setItem(STORAGE_KEY, String(next)); } catch { }
      document.documentElement.classList.toggle('compact', next);
      set({ isCompact: next });
   },
}));